/**
 * Fiskal Cloud Management Admin API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.1.0
 * Contact: info@deutsche-fiskal.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Assignment type: * `businessPremises` - Virtual TSS is assigned to Business Premises (default) * `ers` - Virtual TSS is assigned to a single ERS 
 */
export enum AssignmentTypeEnumDTO {
    BUSINESS_PREMISES = 'businessPremises',
    ERS = 'ers'
}

export class ClsAssignmentTypeEnumDTO {
    BUSINESS_PREMISES = 'businessPremises';
    ERS = 'ers';
}

